export const MEDIA_TYPE_PHOTO = 'Photo'
export const MEDIA_TYPE_VIDEO = 'Video'
export const MEDIA_TYPE_AUDIO = 'Audio'
